export default {
  data: function () {
    return {
      actions: false
    }
  },
  props: {
    meeting: {
      type: Object,
      require: true
    }
  },
  methods: {
    viewActions (status) {
      if (status) {
        this.actions = false
      } else {
        this.actions = true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/meeting/index/components/resources/index.js